import { observable } from 'mobx';
import OutageScheduleReportAPI from '../services/outage-schedule-report-service';
import ReferenceDataService from '../../referencedata/services/reference-data-service';
import { AppConstants, Types } from '../../../common/APIConstants';
import moment from 'moment';
import _ from 'lodash';
import { 
  COMMENTS_HISTORY, 
  SCHEDULING_IMPACT_MITIGATION_PLAN_HISTORY, 
  OPERATION_IMPACT_MITIGATION_PLAN_HISTORY, 
  HISTORICAL_TABLE_COMMENTS,
  HISTORICAL_TABLE_SCHEDULING_MITIGATION_PLAN,
  HISTORICAL_TABLE_OPS_MITIGATION_PLAN
} from '../constants/outage-schedule-report';
import { getActiveResources } from '../utils';

class OutageScheduleReportStore {
  @observable initialValues = '';
  @observable editBtnText = 'Edit';
  @observable addRowBtnText = 'Add New Outage';
  @observable exportBtnText = 'Export';
  @observable refreshBtnText = 'Refresh';
  @observable rowData = [];
  @observable pmcAssetData = [];
  @observable paaAssetData = [];
  @observable pmcDivisionData = [
    { label: 'Control Center', value: 'Control Center' },
    { label: 'Crude', value: 'Crude' },
    { label: 'NGL', value: 'NGL' }
  ]
  @observable paaDivisionData = []
  @observable pmcDistrictData = []
  @observable paaDistrictData = []
  @observable consoleData = [];
  @observable segmentData = [];
  @observable workTypeData = [];
  @observable reasonShutdownData = [];
  @observable eventTypeData = []
  @observable commentData = [];
  @observable screenAcknowledgeData = [];
  @observable columnDefinitions = [];
  @observable ackHistorytData = [];
  @observable loggedUserData = [];
  @observable groupMasterData = [];
  @observable userActiveRegions = []
  @observable userActiveDivisions = []
  @observable userActiveDistricts = []
  @observable userActiveFacilities = []
  @observable headerDetails = {
    startDateTime: '',
    endDateTime: moment().format("MM/DD/YYYY"),
    maxAmbientTemp: '',
    minAmbientTemp: ''
  };
  @observable rowDataFetched = false;
  @observable fields = [
    "AcknowledgedBy",
    "AdvanceNotice",
    "Comments",
    "Console",
    "CreatedBy",
    "CreatedEmail",
    "CreatedOn",
    "CreatedRole",
    "CtrLogisticssAcknowledged",
    "CtrOpsAcknowledged",
    "DateConfirmation",
    "DescriptionOfMaintenance",
    "ControllerOperationalAction",
    "District",
    "Division",
    "Duration",
    "EmailTime",
    "CCRestartDate",
    "EndDate",
    "EventTypeId",
    "EventDescription",
    "Facility",
    "HoursReducedRate",
    "ID",
    "IsAcknowledged",
    "LostVolume",
    "LostVolumeUOM",
    "OperationsImpact",
    "OperationsImpactAndMitigationPlan",
    "OutageType",
    "PinId",
    "PipeSegment",
    "PrimaryContact",
    "ReducedRate",
    "Region",
    "ResponsiblePerson",
    "SchedulingImpact",
    "SchedulingImpactAndMitigationPlan",
    "Section",
    "StartDate",
    "Status",
    "Title",
    "TypeOfWork",
    "UpdatedBy",
    "UpdatedOn"
  ];
  getOutageLoggedUserData = async (userEmail, CommonStore) => {
    try {
      let requestObj = {
        "userEmail": userEmail,
      };
      const { data } = await OutageScheduleReportAPI.getOutageLoggedInUserProfile(requestObj);
      
      if(data?.userList?.length){
        this.userActiveRegions = getActiveResources(data.userList, 'Region')
        this.userActiveDivisions = getActiveResources(data.userList, 'Division')
        this.userActiveDistricts = getActiveResources(data.userList, 'District')
        this.userActiveFacilities = getActiveResources(data.userList, 'Asset')
      }
      
      this.loggedUserData = data.userList;
      this.groupMasterData = data.values;
    } catch (error) {
      this.loggedUserData = [];
    }
  }
  getScreenData = async (currentScreen, CommonStore) => {
    CommonStore.toggleLoader();
    this.hasScreenData = false;
    try {
      let requestObj = {
        "ScreenDetails": currentScreen,
      };
      const { data } = await OutageScheduleReportAPI.getScreenData(requestObj);
      await this.getVolumetricEventType(currentScreen, CommonStore)
      const { screen, screenColumns: columns } = currentScreen;
      this.columnDefinitions = [];
      this.rowData = [];
      this.selectedData = [];

      this.columnDefinitions = this.getColumnDefinitions(screen, columns);
      this.rowData = data;
      this.rowDataFetched = true;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      }
      else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };
  getPmcAssetData = async (currentScreen, CommonStore, filter=[]) => {
    CommonStore.toggleLoader();
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    try {
      shallow.screen.tableName = "OutageSchedule.PMCFacility";
      shallow.screenColumns = [{ name: "ID" }, { name: "ASSET" }];
      shallow.screenFilters = filter
      shallow.orderByQuery = { OrderByQuery: "ASSET ASC" };
      const { data } = await ReferenceDataService.getGridData(shallow);
      this.pmcAssetData = [];
      this.pmcAssetData = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      } else { window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT); }
    }
  };

  getPmcDistrictData = async (currentScreen, CommonStore, filter=[]) => {
    CommonStore.toggleLoader();
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    try {
      shallow.screen.tableName = "OutageSchedule.PMCDistrict";
      shallow.screenColumns = [{ name: "Id" }, { name: "Title" }, {name: 'IsActive'}];
      shallow.screenFilters = filter
      shallow.orderByQuery = { OrderByQuery: "TITLE ASC" };
      const { data } = await ReferenceDataService.getGridData(shallow);
      this.pmcDistrictData = [];
      this.pmcDistrictData = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      } else { window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT); }
    }
  }


  getPaaAssetData = async (currentScreen, CommonStore, filter=[]) => {
    CommonStore.toggleLoader();
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    try {
      shallow.screen.tableName = "OutageSchedule.MxmoFacility";
      shallow.screenColumns = [{ name: "ID" }, { name: "TITLE" }];
      shallow.screenFilters = filter
      shallow.orderByQuery = { OrderByQuery: "TITLE ASC" };

      const { data } = await ReferenceDataService.getGridData(shallow);
      this.paaAssetData = [];
      this.paaAssetData = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      } else { window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT); }
    }
  };

  getPaaDivisionData = async (currentScreen, CommonStore, filter=[]) => {
    CommonStore.toggleLoader();
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    try {
      shallow.screen.tableName = "OutageSchedule.MxmoDivision";
      shallow.screenColumns = [{ name: "ID" }, { name: "TITLE" }];
      shallow.screenFilters = filter
      shallow.orderByQuery = { OrderByQuery: "TITLE ASC" };

      const { data } = await ReferenceDataService.getGridData(shallow);
      this.paaDivisionData = [];
      this.paaDivisionData = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      } else { window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT); }
    }
  };

  getPaaDistrictData = async (currentScreen, CommonStore, filter=[]) => {
    CommonStore.toggleLoader();
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    try {
      shallow.screen.tableName = "OutageSchedule.MxmoDistrict";
      shallow.screenColumns = [{ name: "Id" }, { name: "Title" }, { name: "District_Manager" }, { name: "District_Manager_Email" }, {name: 'Active'}];
      shallow.screenFilters = filter
      shallow.orderByQuery = { OrderByQuery: "TITLE ASC" };

      const { data } = await ReferenceDataService.getGridData(shallow);
      this.paaDistrictData = [];
      this.paaDistrictData = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      } else { window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT); }
    }
  }

  getConsoleData = async (currentScreen, CommonStore, consoleFilter = []) => {
    CommonStore.toggleLoader();
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    try {
      shallow.screen.tableName = "OutageSchedule.Console";
      shallow.screenColumns = [{ name: "ID" }, { name: "Title" }];
      shallow.screenFilters = consoleFilter;
      shallow.orderByQuery = { OrderByQuery: "Title ASC" };

      this.consoleData = [];
      const { data } = await ReferenceDataService.getGridData(shallow);
      this.consoleData = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      } else { window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT); }
    }
  };
  getSegmentData = async (currentScreen, CommonStore, filters=[]) => {
    CommonStore.toggleLoader();
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    try {
      shallow.screen.tableName = "OutageSchedule.PlmSegment";
      shallow.screenColumns = [{ name: "ID" }, { name: "Description" }];
      shallow.screenFilters = filters;
      shallow.orderByQuery = { OrderByQuery: "Description ASC" };
      
      this.segmentData = [];
      const { data } = await ReferenceDataService.getGridData(shallow);
      this.segmentData = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      } else { window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT); }
    }
  };
  getWorkTypeData = async (currentScreen, CommonStore) => {
    CommonStore.toggleLoader();
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    const outageType = shallow.screen.title.split(' ')[0]
    try {
      shallow.screen.tableName = "OutageSchedule.MasterData";
      shallow.screenColumns = [{ name: "ID" }, { name: "NAME" }];
      shallow.screenFilters = [{ name: "Type", value: "TypeOfWork" }, {name: "OutageType", value: outageType}];
      shallow.orderByQuery = { OrderByQuery: "NAME ASC" };
      const { data } = await ReferenceDataService.getGridData(shallow);
      this.workTypeData = [];
      this.workTypeData = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      } else { window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT); }
    }
  };
  getReasonShutdownData = async (currentScreen, CommonStore) => {
    CommonStore.toggleLoader();
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    try {
      shallow.screen.tableName = "OutageSchedule.ReasonShutdown";
      shallow.screenColumns = [{ name: "ID" }, { name: "TITLE" }, { name: "MAIN" }];
      shallow.screenFilters = [];
      shallow.orderByQuery = { OrderByQuery: "ID ASC" };
      const { data } = await ReferenceDataService.getGridData(shallow);
      this.reasonShutdownData = [];
      this.reasonShutdownData = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      } else { window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT); }
    }
  };
  getVolumetricEventType = async (currentScreen, CommonStore) => {
    CommonStore.toggleLoader();
    let shallow = Object.assign({}, _.cloneDeep(currentScreen));
    try {
      shallow.screen.tableName = "OutageSchedule.MasterData";
      shallow.screenColumns = [{ name: "ID" }, { name: "Name" }];
      shallow.screenFilters = [
        {name: 'Status', value: 'Active'},
        {name: 'Type', value: 'EventType'}
      ];
      shallow.orderByQuery = { OrderByQuery: "ID ASC" };
      const { data } = await ReferenceDataService.getGridData(shallow);
      this.eventTypeData = [];
      this.eventTypeData = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      } else { window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT); }
    }
  };
  getCommentsData = async (CommonStore, id, tableName) => {
    CommonStore.toggleLoader();
    this.commentData = [];
    try {
      let requestObj = {
        "ID": id,
        "TableNm": tableName
      };
      let { data } = await OutageScheduleReportAPI.getCommentsData(requestObj);
      if (data?.length) {
        data = data.slice(1)
      }
      if (!data || (data && Object.keys(data).length < 1)) {
        let commentErrMsg = null 
        if(tableName === HISTORICAL_TABLE_COMMENTS)
          commentErrMsg = COMMENTS_HISTORY
        if(tableName === HISTORICAL_TABLE_SCHEDULING_MITIGATION_PLAN)
          commentErrMsg = SCHEDULING_IMPACT_MITIGATION_PLAN_HISTORY
        if(tableName === HISTORICAL_TABLE_OPS_MITIGATION_PLAN)
          commentErrMsg = OPERATION_IMPACT_MITIGATION_PLAN_HISTORY
        window.toastr.info(commentErrMsg);
      } else {
        this.commentData = data;
      }
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      }
      else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };
  getAcknowledgeHistoryData = async (CommonStore, id) => {
    CommonStore.toggleLoader();
    this.commentData = [];
    try {
      let requestObj = {
        "ID": id,
        "TableNm": "Acknowledgements"
      };
      const { data } = await OutageScheduleReportAPI.getCommentsData(requestObj);
      if (!data || (data && Object.keys(data).length < 1)) {
        window.toastr.info("Acknowledgement history not available!");
      } else {
        this.ackHistorytData = data;
      }
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      }
      else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };
  getAcknowledgeData = async (currentScreen, CommonStore, id) => {
    CommonStore.toggleLoader();
    this.hasScreenData = false;
    try {
      let requestObj = {
        "ScreenDetails": currentScreen,
        "Id": id
      };
      const { data } = await OutageScheduleReportAPI.getEditRowData(requestObj);
      const { screen, screenColumns: columns } = currentScreen;
      this.columnDefinitions = [];
      this.rowData = [];
      this.selectedData = [];
      this.screenAcknowledgeData = data;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response && error.response.data.includes("Data not available")) {
        window.toastr.error(error.response.data);
      }
      else {
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
      }
    }
  };
  saveScreenData = async (saveObj, CommonStore, currentScreen, saveMode, EmailOnUpdate, isAcknowledgeUpdate) => {
    CommonStore.toggleLoader();
    try {
      const addScreen = {};
      Object.assign(addScreen, currentScreen);
      addScreen.data = saveObj;
      // const testDate =  addScreen.data.StartDate.toDate();
      
      if (saveMode === "Save") {
        await OutageScheduleReportAPI.saveScreenData(addScreen);
      } else if (saveMode === "Update") {
        addScreen.IsAcknowledgeUpdate = isAcknowledgeUpdate;
        addScreen.EmailOnUpdate = EmailOnUpdate;
        addScreen.UpdatedUserRole = this.loggedUserData[0].GroupNm;
        await OutageScheduleReportAPI.updateData(addScreen);
      } else if (saveMode === "Delete") {
        await OutageScheduleReportAPI.deleteData(addScreen);
      }
      window.toastr.success(AppConstants.TOASTER_SUCCESS);
      CommonStore.toggleLoader();
    }
    catch (error) {
      CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_SAVE_TEXT);
    }
  };
  getColumnDefinitions = (screen, columns) => {
    const gridColumns = [];
    columns.forEach((column) => {
      gridColumns.push({
        field: column.name,
        headerName: column.title,
        type: 'text',
        hide: column.hidden,
        width: column.width ? column.width : 200,
        keyCreator: (params) => { return this.getValueFomatter(params, column, screen) ? this.getValueFomatter(params, column, screen) : params.value },
        editable: (params) => { return this.getIsEditable(params, column, screen) },
        cellClassRules: {
          'highlight-cell': (params) => { return this.getIsEditable(params, column, screen) },
          'grid-cell-custom': (params) => { return params.data ? true : false }
        },
        filter: this.getColumnFilter(column),
        filterParams: this.getColumnFilterParams(column),
        cellRenderer: this.getCellRenderer(column),
        //cellRendererParams: (params) => this.getCellRendererParams(column, params),
        cellEditor: this.getCellEditor(column),
        cellEditorParams: (params) => this.getCellEditorParams(column, params),
        valueFormatter: (params) => { return this.getValueFomatter(params, column, screen) }
      });
    });
    return gridColumns;
  };
  getIsEditable(params, column, screen) {
    return true;
  }
  getCellRenderer(column) {
    switch (column.type) {
      case Types.BOOLEAN:
        return 'booleanTextFormatter';
      case Types.DATETIME:
        return 'dateFormatter';
    }
    if(column.name === 'PinId'){
      return 'PinId'
    }
  }

  getCellEditor(column) {
    switch (column.type) {
      case Types.DROPDOWN:
        return 'SmartSelect';
    }
  }
  getCellEditorParams(column, params) {

    switch (column.type) {
      case Types.DROPDOWN:
        return { values: column.refLookupData?.lookupValues.values, isPopup: true };
    }
  }
  getColumnFilter(column) {
    if (column.name == "StartDate" || column.name == "EndDate" || column.name == "CCRestartDate") {
      return 'agDateColumnFilter';
    } else {
      switch (column.type) {
        case Types.DATE:
          return 'agDateColumnFilter';
        case Types.DATETIME:
          return 'agDateColumnFilter';
        case Types.NUMBER:
          return 'agNumberColumnFilter';
        case Types.DECIMAL:
          return 'agNumberColumnFilter';
        case Types.TEXT:
          return 'agTextColumnFilter';
        default:
          return 'agSetColumnFilter';

      }
    }
  }

  getColumnFilterParams(column) {
    const dateFilterParams = {
      // provide comparator function
      comparator: function (filterLocalDateAtMidnight, cellValue) {
        //using moment js
        var dateAsString = moment(cellValue).format('DD/MM/YYYY');
        var dateParts = dateAsString.split("/");
        var cellDate = new Date(Number(dateParts[2]), Number(dateParts[1]) - 1, Number(dateParts[0]));

        if (filterLocalDateAtMidnight.getTime() == cellDate.getTime()) {
          return 0
        }

        if (cellDate < filterLocalDateAtMidnight) {
          return -1;
        }

        if (cellDate > filterLocalDateAtMidnight) {
          return 1;
        }
      }
    };

    if (column.name == "StartDate" || column.name == "EndDate" || column.name == "CCRestartDate") {
      return dateFilterParams;
    } else return null;

  }

  getValueFomatter(params, column, screen) {
    if (params.value) {
      if (column.type === Types.DROPDOWN && column.refLookupData != null) {
        return this.lookupValue(column.refLookupData.lookupValues, params.value);
      }
      if(column.name === 'EventTypeId'){
        const eventType = this.eventTypeData.find(item => item.ID === params.value)?.Name || params.value
        return eventType
      }
      else {
        if (column.name == "StartDate" || column.name == "EndDate" || column.name == "CCRestartDate") {
          return 'dateFormatter';
        }
        switch (column.type) {
          case Types.DATETIME:
            return 'dateTimeFormatter';

        }

      }
    }
    switch (column.type) {
      case Types.BOOLEAN:
        var value = params.value;
        return ((value && value == "Yes") || (value && value == true)) ? "Yes" : "No";
    }
  }

  lookupValue(mappings, key) {
    if (!mappings || mappings === 'undefined' || !mappings.values.find(item => item.value == key)) return null;
    else {
      let label = mappings.values.find(item => item.value == key).label;
      return label;
    }
  }
  getInitialValues() {
    this.initialValues = {
      AcknowledgedBy: '',
      AdvanceNotice: '',
      Comments: '',
      Console: '',
      CreatedBy: '',
      CreatedEmail: '',
      CreatedOn: '',
      CreatedRole: '',
      CtrLogisticssAcknowledged: '',
      CtrOpsAcknowledged: '',
      DescriptionOfMaintenance: '',
      ControllerOperationalAction:'',
      Duration: '',
      District: '',
      Division: '',
      CCRestartDate: '',
      EndDate: '',
      EventTypeId: '',
      EventDescription: '',
      Facility: '',
      HoursReducedRate: '',
      ID: '',
      IsAcknowledged: '',
      LostVolume: null,
      LostVolumeUOM: '',
      OperationsImpact: '',
      OperationsImpactAndMitigationPlan: '',
      OutageType: '',
      PinId: '',
      PipeSegment: '',
      PrimaryContact: '',
      Region: '',
      ReducedRate: '',
      ResponsiblePerson: '',
      SchedulingImpact: '',
      SchedulingImpactAndMitigationPlan: '',
      Section: '',
      StartDate: new Date(),
      Status: '',
      Title: '',
      TypeOfWork: '',
      UpdatedBy: '',
      UpdatedOn: ''
    }
  }

  getNorthFormDropdownOptions = async (currentScreen, CommonStore, filters) => {
    const assetFilter = filters?.assetFilter || []
    const districtFilter = filters?.districtFilter || []
    const reasonShutDownOrTypeOfWorkFilter = filters?.reasonShutDownOrTypeOfWorkFilter || []

    await this.getPmcAssetData(currentScreen, CommonStore, assetFilter)
    await this.getPmcDistrictData(currentScreen, CommonStore, districtFilter)
    await this.getWorkTypeData(currentScreen, CommonStore, reasonShutDownOrTypeOfWorkFilter)
  }

  getSouthFormDropdownOptions = async (currentScreen, CommonStore, filters) => {
    const assetFilter = filters?.assetFilter || []
    const divisonFilter = filters?.divisonFilter || []
    const districtFilter = filters?.districtFilter || []
    const pipeSegmentFilter = filters?.pipeSegmentFilter || []
    const consoleFilter = filters?.consoleFilter || []
    const reasonShutDownOrTypeOfWorkFilter = filters?.reasonShutDownOrTypeOfWorkFilter || []

    await this.getPaaDivisionData(currentScreen, CommonStore, divisonFilter)
    await this.getPaaDistrictData(currentScreen, CommonStore, districtFilter)
    await this.getPaaAssetData(currentScreen, CommonStore, assetFilter)
    await this.getReasonShutdownData(currentScreen, CommonStore, reasonShutDownOrTypeOfWorkFilter)
    await this.getConsoleData(currentScreen, CommonStore, consoleFilter)
    await this.getSegmentData(currentScreen, CommonStore, pipeSegmentFilter)
  }

  clearDataOnRegnChange = () => {
    this.pmcAssetData = [] 
    this.paaAssetData  = []
    this.consoleData = []
    this.segmentData = []
    this.workTypeData  = []
    this.reasonShutdownData = []
    this.pmcDistrictData = []
    this.paaDivisionData = []
    this.paaDistrictData = []
  }
  clearDataOnDivisionClick = () => {
    this.pmcAssetData = [] 
    this.paaAssetData  = []
    this.pmcDistrictData = []
    this.paaDivisionData = []
    this.paaDistrictData = []
  }
  makeActiveDistList = (region) => {
    if(region === 'Plains - North') {
      const status = this.pmcDistrictData.map(item => item.IsActive)
      if(status.includes(false))
      this.pmcDistrictData = this.pmcDistrictData.filter(dist => dist.IsActive === true)
    }
    if(region === 'Plains - South') {
      const status = this.paaDistrictData.map(item => item.Active)
      if(status.includes(false))
      this.paaDistrictData = this.paaDistrictData.filter(dist => dist.Active === true)
    }
  }
}

export default new OutageScheduleReportStore();